import * as React from "react";
const SvgMiter = (props) => /* @__PURE__ */ React.createElement("svg", { id: "icon-join-miter", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7 15H4V4h11v3H7v8z" }));
export default SvgMiter;
